// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';

export default function CommitTextArea({
  value,
  onCommit,
  placeholder,
  ariaLabel,
  disabled,
  maxLength,
  style,
}: {
  value: string;
  onCommit?: ((raw: string) => void) | null;
  placeholder?: string;
  ariaLabel?: string;
  disabled?: boolean;
  maxLength?: number;
  style?: React.CSSProperties;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || '');
  const skipCommit = useRef(false);

  useEffect(() => {
    if (!editing) setDraft(value || '');
  }, [value, editing]);

  return (
    <textarea
      value={editing ? draft : value || ''}
      placeholder={placeholder}
      aria-label={ariaLabel}
      disabled={disabled}
      maxLength={maxLength}
      rows={2}
      onClick={(e) => e.stopPropagation()}
      onFocus={() => {
        skipCommit.current = false;
        setDraft(value || '');
        setEditing(true);
      }}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        setEditing(false);
        if (skipCommit.current) {
          skipCommit.current = false;
          return;
        }
        if (draft.trim() === (value || '').trim()) return;
        if (typeof onCommit === 'function') onCommit(draft);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          skipCommit.current = true;
          (e.target as HTMLTextAreaElement).blur();
        }
      }}
      style={style}
    />
  );
}
